import { render, staticRenderFns } from "./ConfirmIdentity.vue?vue&type=template&id=777e3266&scoped=true&"
import script from "./ConfirmIdentity.vue?vue&type=script&lang=ts&"
export * from "./ConfirmIdentity.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmIdentity.vue?vue&type=style&index=0&id=777e3266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777e3266",
  null
  
)

export default component.exports